import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DialogService } from 'primeng/dynamicdialog';

import { AlertComponent } from './alert/alert.component';
import { AlertV2Component } from './alert-v2/alert-v2.component';
import { BtnAutoFocus } from './autofocus.directive';
import { SharedLoadingComponent } from './shared-loading/shared-loading.component';
import { SharedAsyncStateComponent } from './shared-loading/shared-async-state.component';

@NgModule({
  declarations: [
    AlertComponent,
    AlertV2Component,
    BtnAutoFocus,
    SharedLoadingComponent,
    SharedAsyncStateComponent,
  ],
  imports: [
    CommonModule,    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
  ],
  exports: [
    MatIconModule,
    MatProgressSpinnerModule,
    AlertComponent,
    AlertV2Component,
    BtnAutoFocus,
    SharedLoadingComponent,
    SharedAsyncStateComponent,
  ],
  providers: [DialogService],
})
export class CoreUiModule {}
